import { HttpAccountResource } from './resources/account.js';
import { HttpActivitiesResource } from './resources/activities.js';
import { HttpAttachmentsResource } from './resources/attachments.js';
import { HttpClient } from './core/http-client.js';
import { HttpAuthResource } from './resources/auth.js';
import { HttpEventsResource } from './resources/events.js';
import { HttpLibraryResource } from './resources/library.js';
import { HttpMessagingResource } from './resources/messaging.js';
import { HttpMultipartResource } from './resources/multipart.js';
import { HttpParametersResource } from './resources/parameters.js';
import { HttpPersonResource } from './resources/person.js';
import { HttpSubscriptionsResource } from './resources/subscriptions.js';
export class HttpApiClient {
    account;
    activities;
    attachments;
    auth;
    events;
    library;
    messaging;
    multipart;
    parameters;
    person;
    subscriptions;
    #httpClient;
    constructor(options) {
        this.#httpClient = new HttpClient(options);
        this.account = new HttpAccountResource(this.#httpClient);
        this.activities = new HttpActivitiesResource(this.#httpClient);
        this.attachments = new HttpAttachmentsResource(this.#httpClient);
        this.auth = new HttpAuthResource(this.#httpClient);
        this.events = new HttpEventsResource(this.#httpClient);
        this.library = new HttpLibraryResource(this.#httpClient);
        this.messaging = new HttpMessagingResource(this.#httpClient);
        this.multipart = new HttpMultipartResource(this.#httpClient);
        this.parameters = new HttpParametersResource(this.#httpClient);
        this.person = new HttpPersonResource(this.#httpClient);
        this.subscriptions = new HttpSubscriptionsResource(this.#httpClient);
    }
    abortAllRequests() {
        this.#httpClient.abortAllRequests();
    }
}
